<span> در حال به‌روز رسانی تراکنش‌ها... </span>

<div class="loader"></div>
